// @ts-nocheck

import { type RegulationState } from '../states/regulation';
import { RegulationActionTypes } from '../types/actions/regulation';

const initialState: RegulationState = {};

const handledActionTypes = [
  RegulationActionTypes.SET_REALITY_CHECK_MESSAGE,
  RegulationActionTypes.DISMISS_REALITY_CHECK_MESSAGE,
];

const regulationReducer = (state: RegulationState = initialState, action: unknown) => {
  if (~handledActionTypes.indexOf(action.type)) {
    if (action.type === RegulationActionTypes.SET_REALITY_CHECK_MESSAGE) {
      const { message } = action.payload;

      return {
        ...state,
        message,
      };
    }

    if (action.type === RegulationActionTypes.DISMISS_REALITY_CHECK_MESSAGE) {
      const nextState = { ...state };
      delete nextState.message;
      return nextState;
    }
  }

  return state;
};

export default regulationReducer;
